var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmokeDetector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#464646"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.5 15.5c1.2-.5 2-1.6 2-3v-1.1h-21v1.1c0 1.4.8 2.5 2 3M11.5 15.5c.4.1.8.2 1.2.2h14.6c.4 0 .8-.1 1.2-.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 15.5v4c0 3.5 2.1 6.6 5.1 7.9v-3.1c0-1.9 1.5-3.5 3.4-3.5s3.4 1.6 3.4 3.5v3.1c3-1.3 5.1-4.4 5.1-7.9v-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 20.9c-1.9 0-3.4 1.6-3.4 3.5v3.1c1.1.5 2.2.7 3.4.7s2.4-.3 3.4-.7v-3.1c0-1.9-1.5-3.5-3.4-3.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 24.4c0-.6.4-1 1-1 .5 0 1 .4 1 1s-.4 1-1 1c-.5 0-1-.5-1-1Z"
}))));
export default SvgSmokeDetector;